import React, { useCallback, useEffect, useMemo, useState } from 'react';
import get from 'lodash/get';
import isString from 'lodash/isString';
import { PaginationContext } from '@yme/atoms/pagination/paginationContext';
import { buildKey, scrollToId } from '@yme/utils/common';
import { PaginationItem } from './PaginationItem';
import { PerPage } from './PerPage';
import { FlexWrapperStyled, PaginationStyled } from './styled';
export function Pagination({ isRightToLeft = false, paginationData, isMobileView = false, isSizeChanged = false, paginationConfig, activeItemValue, onClickItemHandler, perPageLabel, getPerPageLimit, currentPerPageValue, setCurrentPerPageValue, scrollToElement, }) {
    const [perPageLimit, setPerPageLimit] = useState(0);
    const contextValue = useMemo(() => ({
        perPageLimit,
        setPerPageLimit,
    }), [perPageLimit]);
    const onScrollingToHandler = useCallback(() => {
        const currentElementId = get(scrollToElement, 'id', null);
        const yOffset = get(scrollToElement, 'yOffset', 0);
        if (isString(currentElementId)) {
            scrollToId({
                id: currentElementId,
                yOffset,
            });
        }
    }, [scrollToElement]);
    const onClickPaginationItemHandler = useCallback(({ item, isDisabled, isActiveItem, }) => () => {
        onClickItemHandler({
            item,
            isDisabled,
            isActiveItem,
        });
        onScrollingToHandler();
    }, [onClickItemHandler, onScrollingToHandler]);
    const setCurrentPerPageValueHandler = useCallback((id) => {
        setCurrentPerPageValue(id);
        onScrollingToHandler();
    }, [onScrollingToHandler, setCurrentPerPageValue]);
    useEffect(() => {
        const isPageLimitChanged = paginationData?.activeElement && paginationData?.activeElement !== perPageLimit;
        if (getPerPageLimit && perPageLimit && isPageLimitChanged && !isSizeChanged) {
            getPerPageLimit((prev) => ({
                ...prev,
                limit: prev.limit !== perPageLimit ? perPageLimit : prev.limit,
                currentPage: 1,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPerPageLimit, perPageLimit]);
    return (React.createElement(PaginationContext.Provider, { value: contextValue },
        React.createElement(FlexWrapperStyled, { isRightToLeft: isRightToLeft, flexDirection: isMobileView ? 'column' : 'row', justifyContent: "space-between", alignItems: "center", gap: "16px", isFullWidth: true },
            React.createElement(PaginationStyled, { isRightToLeft: isRightToLeft }, paginationConfig.map((item, index) => {
                const isActiveItem = Boolean(item?.value === activeItemValue);
                const isDisabled = Boolean(item?.isDisabled);
                return (React.createElement(PaginationItem, { key: buildKey(index, item?.value), type: item?.type, isRightToLeft: isRightToLeft, isActive: isActiveItem, isDisabled: isDisabled, onClick: onClickPaginationItemHandler({
                        item,
                        isDisabled,
                        isActiveItem,
                    }) }, item?.value || item?.children));
            })),
            React.createElement(PerPage, { perPageOptions: paginationData?.perPageOptions, perPageLabel: perPageLabel, currentPerPageValue: currentPerPageValue, setCurrentPerPageValue: setCurrentPerPageValueHandler }))));
}
Pagination.displayName = 'Pagination';
